import script from "./EditDashboard.vue?vue&type=script&lang=js"
export * from "./EditDashboard.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__